import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const WhoopsIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Whoops - rhythmic bumps */}
    <path d="M2 18c0-2 1.5-4 3-4s3 2 3 4" />
    <path d="M8 18c0-2 1.5-4 3-4s3 2 3 4" />
    <path d="M14 18c0-2 1.5-4 3-4s3 2 3 4" />
    <path d="M20 18h2" />
    <path d="M2 18h20" />
  </svg>
);
